<template>
  <div class="u-align--left intro">
    <h2 class="title">Quel traitement pour votre patient&nbsp;?</h2>

    <!-- Link to the pathology -->
    <dropdown
           :theme="'white'" @pathology-selected="pathologySelectionListener"
    />

    <div class="row description">
      <div>
        <ul class="adv">
			<li><b>une application rapide pour le choix du traitement</b></li>
			<li><b>basée sur les dernières recommandations officielles en vigueur</b></li>
			<li><b>mise à jour régulièrement</b></li>
			<li><b>Vous &ecirc;tes un patient &nbsp;?</b><br />Toutes les infos sont sur <a target="_blank" href="https://dermato-info.fr/">dermato-info.fr</a></li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
  import Dropdown from "../Core/Dropdown";
  export default {
    name: "Introduction",
    props: ['pathologies'],
    components: {Dropdown},
    methods: {
      /**
       * The component Dropdown will emit an event when a pathology is selected.
       * This listener has to manage this event.
       *
       * @param pathologySlug
       */
      pathologySelectionListener(pathologySlug) {
        // redirect to the pathology form
        this.$router.push({name: 'recommendation_pathology', params: { pathology: pathologySlug } });
      }
    },
  }
</script>

<style lang="scss">
.intro {

	padding-left:3em;

	  .title {
	    font-size: rem(36px);
	    line-height: rem(36px);
	    color:rgb(128, 0, 128);
	    margin: rem(30px) 0 0;
	    text-shadow:0 0 1em color(back);

	    @include mq($until: MD) {
	      font-size: rem(24px);
	      line-height: rem(30px);
	    }
	  }

  .description {
    color: color(skin);
    padding: rem(35px) 0;
    font-weight: 400;

    ul {
      padding-left: rem(20px);
      margin: 0;

      li {
        font-size: rem(16px);
        line-height:1.33em;
        padding: rem(5px);
        color:color(skin-dark);

        b {font-weight:bold;color:color(skin);line-height:1}

        @include mq($until: MD) {
          font-size: rem(14px);
          line-height: rem(21px);
        }

        a {
          text-decoration: underline;
          color:inherit;
        }

        &:last-child {list-style:none}

      }
    }

    img {
      max-width: rem(120px);

      @include mq($until: MD) {
        display: none;
      }
    }
  }

  .filter-pathologies {
    background-color: color(blue);
    color: white;
    border: none;

    .dropdown span {white-space:normal}

    .drop-link {
      color: color(blue);
    }
  }

  .cta-round {
    &:hover, &:focus {
      background-color: color(blue-hover);
      text-decoration: underline;
    }
  }

  #dropdown {margin-top:3em}


    @include mq($until: MD) {
      padding:0 1em;

      .dropdown {margin-right:1em}

    }



}

</style>
